export const environment = {
  STRIPE_PUBLIC_API_KEY: "pk_test_51SuFsH3mzdw7QCxfNaCXKBF9NzCEc4i9UtJHXQiwQaKhG3iy2YblUPFHtHFDcPs5a4KfYhHo0EcY1JlSWQ0kHH8N00X44wEhyt",
  API_URL: "https://17bx575oxl.execute-api.us-east-1.amazonaws.com",
  COGNITO_USER_POOL_ID: "us-east-1_mNTHmkVBB",
  COGNITO_WEB_CLIENT_APP_ID: "7e77oj9t00qakod07crel9s82t",
  SDK_SUBDOMAIN: "devsdk",
  STRIPE_INDVIDUAL_PRICE_ID: "price_1SuIEG3mzdw7QCxfO5FEdM8m",
  STRIPE_POWER_PRICE_ID: "price_1SuIFP3mzdw7QCxfqSmw4LT7",
  STRIPE_FLEET_PRICE_ID: "price_1SuIFq3mzdw7QCxfEWPNKv9B"
};
